import { combineReducers } from '@reduxjs/toolkit';
import questionnaire from '@store/sagas/questionnaire';
import { createRouterReducer } from '@lagunovsky/redux-react-router';
import { browserHistory } from '@utils/history';

export const rootReducer = combineReducers({
  router: createRouterReducer(browserHistory),
  app: questionnaire
});
